module.exports = __webpack_public_path__ + "static/media/image11.ad0029f8.png";